import { ThreeDots } from '@toggle/design-system';
import React from 'react';

import { ScreeningEntities } from '~/stores/use-chat/assistant-response.type';
import { AssetScreeningWidget } from '~/widgets/asset-screening-widget/AssetScreeningWidget';

import { useScreeningData } from '../use-screening-data/useScreeningData';

type ScreeningMessageDataProps = {
  entities: ScreeningEntities[];
};

export const ScreeningMessageData = ({
  entities,
}: ScreeningMessageDataProps) => {
  const { loading, rowData, columns } = useScreeningData(entities);

  if (loading) {
    return <ThreeDots />;
  }

  const uniqueSnakesColumns = [...new Set(columns)].map(key => ({ key }));
  return (
    <AssetScreeningWidget data={rowData} columnsData={uniqueSnakesColumns} />
  );
};
